/**
 * 使用费查询模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const useCharge = {
    //得到使用费数据集合
    list(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/registpay/list`, { params: params});
    },
}

export default useCharge;



// WEBPACK FOOTER //
// ./src/api/useCharge.js